import React from 'react';
import QuestionCard from './questionCard';
import { useParams } from 'react-router-dom';
import { trackQuizCompleted, trackLessonCompleted } from '../../../lib/analytics';
import { getVideoLessonProgress } from '../../../lib/videoLessonApi';

const QuestionCardExample = ({ onActivityComplete }) => {
    const { id } = useParams(); // Get video lesson ID from URL params
    
    const handleTestComplete = async (results) => {
        console.log('Test completed!', results);
        
        // Track quiz completion
        const lessonId = id ? parseInt(id, 10) : null;
        const score = results.percentage || 0; // Score is percentage (0-100)
        
        if (lessonId) {
            trackQuizCompleted(lessonId, score);
            
            // Check if lesson is completed
            const progress = await getVideoLessonProgress(lessonId);
            if (progress?.completion_status === 'COMPLETED') {
                trackLessonCompleted(lessonId);
            }
        }
        
        // Handle test completion - save results, show summary, etc.
        // You can send results to your analytics, update user progress, etc.
    };

    return (
        <div>
            {/* Example 1: Using backend questions (recommended for production) */}
            {id ? (
                <QuestionCard
                    videoLessonId={parseInt(id, 10)} // Convert URL param to number
                    onTestComplete={handleTestComplete}
                    onActivityComplete={onActivityComplete} // Pass through completion check
                    maxAttempts={2} // Optional: default is 2
                    enabledTestTypes={{ // Optional: control which test types are available
                        yesNo: true,
                        textVoice: true,
                        dragDrop: false // Disable drag & drop for now since backend doesn't support it yet
                    }}
                />
            ) : (
                <div>No video lesson ID provided</div>
            )}

            {/* Example 2: Using sample questions (fallback/development) */}
            {/* 
            <QuestionCard
                // Don't pass videoLessonId to use sample questions
                onTestComplete={handleTestComplete}
                onActivityComplete={onActivityComplete}
                maxAttempts={2}
                enabledTestTypes={{
                    yesNo: true,
                    textVoice: true,
                    dragDrop: true // Sample questions include drag & drop
                }}
            />
            */}
        </div>
    );
};

export default QuestionCardExample;